export let hoverTooltipWithoutDuplication = "TGc87";
export default {hoverTooltipWithoutDuplication};